/* istanbul ignore file - need to fix flakey tests */
import { LoadingSpinner } from '@components/Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@partful/shared/ui/Typography';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useDecodedParams } from 'src/hooks/useDecodedParams';
import styles from './PartsCategoriesDataTable.module.scss';

const iconToRender = {
  error: <FontAwesomeIcon icon="table-tree" className={styles.errorIconStyle} />,
  loading: <LoadingSpinner />,
};

const headingToRender = (t: TFunction<'manageProduct'>, productName: string) => ({
  error: t('partsCategories.currentPartsCategories.errorDisplayingProductPartCategoriesTitle', { productName }),
  loading: t('partsCategories.currentPartsCategories.loadingPartsCategoriesTitle', { productName }),
});

const textToRender = (t: TFunction<'manageProduct'>) => ({
  error: t('partsCategories.currentPartsCategories.errorDisplayingPartsCategoriesTable'),
  loading: t('partsCategories.currentPartsCategories.loadingPartsCategories'),
});

export function TableStateMessage({ state }: { state: 'loading' | 'error' }) {
  const { t } = useTranslation('manageProduct');
  const { productId } = useDecodedParams<{ productId: string }>();

  return (
    <>
      {iconToRender[state]}
      <div className={styles.tableStateMessageContent}>
        <Typography appearance="heading6" as="h6">
          {headingToRender(t, productId)[state]}
        </Typography>
        <Typography as="p">{textToRender(t)[state]}</Typography>
      </div>
    </>
  );
}
